const getHeader = (
  headers: HeadersInit | undefined,
  name: string
): string | undefined => {
  if (!headers) return undefined;

  if (typeof Headers !== 'undefined' && headers instanceof Headers) {
    return headers.get(name) ?? undefined;
  }

  const normalizedName = name.toLowerCase();
  const entries = Array.isArray(headers) ? headers : Object.entries(headers);
  return entries.find(([key]) => key.toLowerCase() === normalizedName)?.[1];
};

export default getHeader;
